import React, { Component } from 'react';
import { routes } from '../../../../../utility/constants/constants';
import InventoryList from '../../../../component/Inventory/InventoryListComponent/InventoryList';
import * as actions from '../../../../../redux/actions/index';
import { connect } from 'react-redux';
import { reset } from 'redux-form';
import { animateScroll as scroll} from 'react-scroll'
import storage from '../../../../../utility/storage';
import { convertDateToDifferentTZ } from '../../../../../utility/utility';
import errorHandler from '../../../../../utility/errorHandler/errorHandler';
import AvailabilityList from '../../../../component/TimeTrackerModuleComponent/AvailabilityComponent/AvailabilityList/availabilityList';
import { tzUTCDateConverterTool_V2 } from '../../../../../utility/TimezoneOperations/timezoneUtility';

var moment = require('moment');
const cloneDeep = require('clone-deep');

class AvailabilityListContainer extends Component {

    constructor(props) {
        super(props);

        this.state = {
            
        }
    }

    componentDidMount() {
        scroll.scrollToTop();
    }

    componentDidUpdate(prevProps, prevState) {
        const user = storage.get('user');
        if(user) {
            if(prevProps.user.selected_mode !== user.selected_mode) {
                this.props.getAllAvailabilityListPageClicked(0)
            }
        }
    }

    resetClicked = () => {
        const page = 1
        const limit = this.props.availabilityList_no_of_rows
        this.props.reset('availabilityListForm');
        this.props.getAllAvailabilityListPageClicked(0)
        this.props.getAllAvailability({page,limit})

    }

    searchInventoryItemsListClicked = (value) => {
        const values = cloneDeep(value)
        let userName =  null;
        let accountName = null;
        let from = null;
        let to = null;
    
        const page = 1
        const limit = this.props.availabilityList_no_of_rows
        if(values.user) {
            values.user = values.user.trim()
            userName = values.user
        }
      if(values.job) {
        values.job = values.job.trim()
        accountName =  values.job 
        }  
      if(values.fromDate) {debugger
        values.fromDate = tzUTCDateConverterTool_V2(values.fromDate, 'from');
        from = values.fromDate;
      }  
      if(values.toDate) {
        values.toDate = tzUTCDateConverterTool_V2(values.toDate, 'to');
        to = values.toDate;
      }  

      if(from && !to || !from && to ){
        errorHandler(`Both 'From' and 'To' dates are required.`)
        return false
      }
     
        this.props.getAllAvailability({page,limit,userName,accountName,from,to}, values);
    }

    deleteMainShift = (id) => {
        this.props.deleteMainShift(id);
    }

    handleFrequentTimeTracker_openDeleteModal = (value) => {
        this.props.handleFrequentTimeTracker_openDeleteModal(value);
    }

    handleFrequentTimeTracker_closeDeleteModal = () => {
        this.props.handleFrequentTimeTracker_closeDeleteModal();
    }
         
    render() {
        return (
            <AvailabilityList
                {...this.props}
                isLoading={this.props.isLoading}
                onSubmit={this.searchInventoryItemsListClicked}
                resetClicked={this.resetClicked}
                availabilityList={this.props.availabilityList ? this.props.availabilityList : []}
                deleteMainShift={this.deleteMainShift}
                handleFrequentTimeTracker_openDeleteModal={this.handleFrequentTimeTracker_openDeleteModal}
                handleFrequentTimeTracker_closeDeleteModal={this.handleFrequentTimeTracker_closeDeleteModal}
                
            />
        )
    }
}


const mapStateToProps = (state) => {
    return {
        user: state.authReducer.user,
        isLoading: state.TimeTrackerModReducer.isLoading,
        availabilityList: state.TimeTrackerModReducer.availabilityList,
        isAvailabilityList: state.TimeTrackerModReducer.isAvailabilityList,
        availabilityList_no_of_rows: state.TimeTrackerModReducer.availabilityList_no_of_rows,
        availabilityListCurPage: state.TimeTrackerModReducer.availabilityListCurPage,
        openFrequentTimeTracker_deleteModal: state.TimeTrackerModReducer.openFrequentTimeTracker_deleteModal,
        deleteFrequentTimeTracker_object: state.TimeTrackerModReducer.deleteFrequentTimeTracker_object,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        reset: (availabilityListForm) => dispatch(reset(availabilityListForm)),  // requires form name
        getAllAvailabilityListPageClicked: (page) => dispatch(actions.getAllAvailabilityListPageClicked(page)),
        getAllAvailability: (params, values) => dispatch(actions.getAllAvailability(params, values)),
        singleAvailabilityListClicked: (ticket) => dispatch(actions.singleAvailabilityListClicked(ticket)),
        resetObjects: () => dispatch(actions.resetObjects()),
        deleteMainShift: (id) => dispatch(actions.deleteMainShift(id)),
        handleFrequentTimeTracker_openDeleteModal: (value) => dispatch(actions.handleFrequentTimeTracker_openDeleteModal(value)),
        handleFrequentTimeTracker_closeDeleteModal: () => dispatch(actions.handleFrequentTimeTracker_closeDeleteModal()),
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(AvailabilityListContainer);